(ns shared.core.amelia-light.components.loading
  (:require [shared.core.loading :as loading]
            [shared.core.style :as style]
            [shared.core.util :as util]
            ["@up/extended-ui/components/loader" :default Loader]))

(defn gray-spinner [{:keys [style]}]
  [loading/spinner {:size 13.5
                    :color (util/hex->rgba (style/color :black :base) 0.12)
                    :style (merge {:border (str "1px solid " (util/hex->rgba (style/color :black :base) 0.4))}
                                  style)}])

(defn gray-spinner-with-label [{:keys [style spinner-style label label-style]}]
  [:div {:style (merge {:display :flex
                        :justify-content :center
                        :align-items :center
                        :gap 8}
                       style)}
   [gray-spinner {:style spinner-style}]
   [:span {:style (merge {:font-family style/roboto-font-family
                          :font-size 12
                          :line-height "18px"
                          :font-weight style/font-regular-weight
                          :color (util/hex->rgba (style/color :black :base) 0.4)}
                         label-style)}
    label]])

(defn up-loader [& args] (into [:> Loader] args))

(defn up-loader-with-label [{:keys [label loader-size style]}]
  [:div {:style (merge {:flex 1
                        :display :flex
                        :flex-direction :column
                        :align-items :center
                        :justify-content :center
                        :gap 12
                        :width "100%"
                        :min-height "100%"}
                       style)}
   [:div {:style {"--spacing" "0.2344rem"}}
    [up-loader {:size (or loader-size "default")}]]
   [:span {:style {:color (style/alc-color "Text/primary")
                   :font-size 12
                   :font-weight 400
                   :line-height 1.5}}
    label]])
